import Appsignal from '@appsignal/javascript';

let appsignal = null;

if (import.meta.env.VITE_APP_ENV !== 'development' && import.meta.env.VITE_APP_ENV !== 'test') {
  appsignal = new Appsignal({
    key: import.meta.env.VITE_APP_APPSIGNAL_PUSH_API_KEY,
    namespace: "frontend"
  });
}

export { appsignal };
